const EnderecosCadastrar = () => import('@/views/EnderecosCadastrar.vue');
const DadosPessoais = () => import('@/views/DadosPessoais.vue');
const Enderecos = () => import('@/views/Enderecos.vue');

const routes = [
  {
    path: '/meu-perfil/dados-pessoais',
    name: 'dados-pessoais',
    component: DadosPessoais,
    meta: {
      title: 'Dados pessoais',
    },
  },
  {
    path: '/meu-perfil/enderecos',
    name: 'enderecos',
    component: Enderecos,
    meta: {
      title: 'Endereços',
    },
  },
  {
    path: '/meu-perfil/enderecos/cadastrar',
    name: 'enderecos-cadastrar',
    component: EnderecosCadastrar,
    meta: {
      title: 'Cadastrar Endereço',
    },
  },
  {
    path: '/meu-perfil/enderecos/editar/:idEndereco',
    name: 'enderecos-editar',
    component: EnderecosCadastrar,
    props: true,
    meta: {
      title: 'Editar Endereço',
    },
  },
];

export default routes;
